////////////////////////////////////////////////////////
//                      Topics                        //
////////////////////////////////////////////////////////

import { useNodeCanvasStore } from '../../store';
import { Topic } from '../storeClasses/topic';
import { Node } from '../storeClasses/node';
import {
  addDeleteButton,
  addEditButton,
  CanvasOptions,
  getCanvasCurrentPackage
} from './drawCanvas';
import { useGlobalStore } from '@/modules/globalModule/store';
import { Service } from '../storeClasses/service';

export function drawTopic(
  stage: any,
  topic: Topic,
  editing: boolean = false,
  options: CanvasOptions = {}
) {
  // topic container
  const container: any = new createjs.Container();
  container.x = topic.position.x;
  container.y = topic.position.y;
  container.name = 't' + topic.id;
  container.objId = topic.id;

  // topic rectangle graphic
  const rect = new createjs.Shape();
  rect.graphics
    .beginLinearGradientFill(['#5CC8F9', '#0B82C3'], [0, 1], 0, 0, 100, 0)
    .drawRoundRect(0, 0, topic.width, topic.height, topic.radius);
  rect.name = 'tr' + topic.id;
  container.addChild(rect);

  // name text
  const nameText = new createjs.Text(topic.name, '20px Arial', '#000000');
  nameText.x = -(nameText.getMeasuredWidth() - topic.width) / 2;
  nameText.y = -(nameText.getMeasuredHeight() - topic.height) / 2;
  nameText.name = 'tt' + topic.id;
  container.addChild(nameText);
  let mousedownCount = 0;
  // movement
  rect.on('mousedown', function (evt: any) {
    const ncStore = useNodeCanvasStore();
    ncStore.currDragOffset = {
      x: evt.stageX - container.x,
      y: evt.stageY - container.y
    };
    // If currDragOffset is identical to the drag offset in 300 ms, then we record a hold down that has taken that amount of time
    // We know that they have no pressed up if mousedownCount is not equal to 0 as mousedownCount is reset on pressup
    mousedownCount++;
    setTimeout(() => {
      const cmp1 = JSON.stringify(ncStore.currDragOffset);
      const cmp2 = JSON.stringify({
        x: evt.stageX - container.x,
        y: evt.stageY - container.y
      });
      if (cmp1 == cmp2 && mousedownCount != 0) {
        rect.dispatchEvent('dblclick');
      }
      mousedownCount = 0;
    }, 400);
  });
  rect.on('pressup', () => {
    mousedownCount = 0;
    if (options?.pressUp !== undefined) {
      options.pressUp();
      return;
    }
    const ncStore = useNodeCanvasStore();
    ncStore.dragObjId = 'undefined';
  });
  rect.on('pressmove', function (evt: any) {
    if (options?.pressMove !== undefined) {
      options.pressMove(evt);
      return;
    }
    let ncStore = useNodeCanvasStore();
    ncStore.dragObjId = topic.id;
    container.x = evt.stageX - ncStore.currDragOffset.x;
    container.y = evt.stageY - ncStore.currDragOffset.y;
    ncStore.moveObj(topic.id, container.x, container.y);
  });

  // edit topic funcitonality
  rect.on('dblclick', function () {
    let ncStore = useNodeCanvasStore();
    ncStore.editingTopicId = topic.id;
  });

  // functionality once editing topic finished
  stage.on('editTopicEnd', function () {
    nameText.text = topic.name;
    nameText.x = -(nameText.getMeasuredWidth() - topic.width) / 2;
    nameText.y = -(nameText.getMeasuredHeight() - topic.height) / 2;
  });

  // edit buttons
  if (options.noDelBtn === undefined) {
    const delBtn = addDeleteButton(stage, container, topic, -16, -16);
    delBtn.visible = editing;
  }
  const editBtn = addEditButton(
    stage,
    container,
    topic,
    topic.width - 17,
    -17,
    't'
  );
  editBtn.visible = editing;
  if (options.noShadow === undefined) {
    rect.shadow = new createjs.Shadow('#7F7F7F', 5, 5, 1);
  }
  // stage.addChild(container);
  return container;
}

export function addNewTopic(stage: any, x: number, y: number) {
  const pkg = getCanvasCurrentPackage();
  const globalStore = useGlobalStore();
  if (!pkg) return;
  const newTopic = globalStore.createTopicInPkg(pkg.id, {
    x: x,
    y: y,
    name: `Topic ${pkg.topics.length + 1}`
  });
  stage.addChild(drawTopic(stage, newTopic, true));
  return newTopic;
}

export function initTopics(stage: any) {
  const pkg = getCanvasCurrentPackage();
  if (!pkg) return;
  pkg.topics.forEach((topic) => {
    stage.addChild(drawTopic(stage, topic));
  });
}

export function onTopicArcPressup(topic: Topic, other: Node | Service | Topic) {
  if (other instanceof Node) {
    useNodeCanvasStore().connectingTopicNode = {
      topic: topic.id,
      node: other.id
    };
  }
}
